import { render, staticRenderFns } from "./fcclock_hubconfiguration_details.vue?vue&type=template&id=028e62ad"
import script from "./fcclock_hubconfiguration_details.vue?vue&type=script&lang=js"
export * from "./fcclock_hubconfiguration_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports